<template>
  <div class="column-name add-to-cart" v-if="formDefs.length">
    <template v-for="formDef in innerFormDefs">
      <counter
        v-if="formDef.Interpretation === interpretations.counter"
        :formData="formData"
        :elementDef="formDef"
        @change="_change"
      />
      <my-button
        @buttonClicked="buttonClicked"
        :def="def"
        :rowData="rowData"
        :elementDef="formDef"
        :updateDataRequest="updateDataRequest"
        v-if="formDef.Interpretation === interpretations.button || formDef.Interpretation === interpretations.buttonS"
      />
    </template>
  </div>
</template>

<script>
import Counter         from './elements/counter'
import MyButton        from './elements/button'
import Interpretations from '../../../../model/interpretations'

export default {
  components: {
    Counter,
    MyButton
  },

  props: {
    def:               {
      type:    Object,
      default: function () {
        return null
      }
    },
    formDefs:          {
      type:    Array,
      default: function () {
        return []
      }
    },
    rowData:           {
      type:    Object,
      default: function () {
        return {}
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    }
  },

  data () {
    return {
      interpretations: Interpretations,
      elementsDef:     [],
      formData:        {},
      innerFormDefs:   []
    }
  },

  created () {
    this._initBase()
  },

  watch: {
    formDefs: function () {
      this.formData = {}
      this._initBase()
    }
  },

  beforeUpdate () {
    this._initBase()
  },

  methods: {
    /**
     *
     * @param args
     * @private
     */
    _change (args) {
      this.formData[args.key] = args.value
    },

    /**
     *
     * @private
     */
    _initBase () {
      this.innerFormDefs = []
      this.formData      = {}

      this.formDefs.forEach((item) => {
        this.innerFormDefs.push(item)
        this.formData[item.Field] = this.rowData[item.ColumnName]

        if (item.hasOwnProperty('Fields') && item.Fields.length) {
          item.Fields.forEach((subItem) => {
            this.innerFormDefs.push(subItem)
          })
        }
      })
    },

    buttonClicked () {
      this.$emit('buttonClicked')
    },

    /**
     *
     * @returns {default.props.rowData|{default, type}}
     */
    getData () {
      return { ...this.rowData, ...this.formData }
    }
  }
}
</script>

<style scoped>

</style>
